/**
 * Returns a Tailwind text color class based on a success rate percentage.
 * >= 99% = green, >= 90% = yellow, < 90% = red
 */
export const getSuccessRateColor = (percent: number): string => {
  if (percent >= 99) {
    return 'text-green-600';
  }
  if (percent >= 90) {
    return 'text-yellow-600';
  }
  return 'text-red-600';
};
